import React, { Component } from "react";
import classnames from "classnames";

export class Accordion extends Component {
  render() {
    return (
      <ul className="uk-accordion nacc-accordion" data-uk-accordion="multiple: true">
        {this.props.children}
      </ul>
    );
  }
}

export class AccordionLite extends Component {
  render() {
    return (
      <ul
        className={classnames("uk-accordion uk-margin-remove-first-child", this.props.className)}
        data-uk-accordion="multiple: true"
      >
        {this.props.children}
      </ul>
    );
  }
}

export class AccordionItem extends Component {
  render() {
    return (
      <li id={this.props.id}>
        <button className="uk-accordion-title uk-text-left uk-width-1-1" href="#">
          {this.props.buttonText}
          <div className="uk-width-2-3@m uk-width-1-1@s">
            <p className="uk-h5 accordion-subtitle uk-margin-bottom">{this.props.subText}</p>
          </div>
        </button>
        <div className="uk-accordion-content">
          <div className="uk-padding uk-padding-small-bottom">{this.props.children}</div>
        </div>
      </li>
    );
  }
}

export class AccordionItemLite extends Component {
  render() {
    return (
      <li className="uk-margin-top uk-width-1-1">
        <div className="uk-accordion-title uk-text uk-flex uk-flex-row-reverse uk-flex-center">
          <div style={{ fontWeight: 400, fontSize: "1.1rem", cursor: "pointer" }} className="uk-width-2-3@m">
            {this.props.buttonText}
          </div>
        </div>
        <div className="uk-accordion-content uk-margin-left uk-margin-large-right uk-flex uk-flex-center ">
          <div
            style={{ fontSize: "1.1rem" }}
            className=" uk-width-2-3@m uk-background-muted uk-padding uk-border-rounded uk-box-shadow-small"
          >
            {this.props.children}
          </div>
        </div>
      </li>
    );
  }
}
